/*eslint-disable*/ export const messages = JSON.parse("{\"radio-group.validation.required\":[\"Vælg en mulighed.\"],\"radio-group.label.optional\":[\"Valgfri\"]}");
//# sourceMappingURL=messages.mjs.map